export const getScrollContainer = (
	from: HTMLElement | null,
): HTMLElement | null => {
	let el: HTMLElement | null = from?.parentElement ?? null;
	while (el) {
		const overflowY = window.getComputedStyle(el).overflowY;
		if (overflowY === "auto" || overflowY === "scroll") return el;
		el = el.parentElement;
	}
	return null;
};
